'use strict';

import config from '../utils/config';
import layout from'../ui/layout';
import screenSizeWatcher from '../watchers/screen-size-watcher'

function formatSize(size) {
	return '_' + size + '_';
}

function updateScreenSizeHint() {
	let title = document.title.replace(/_(S|M|L|XL|XXL)_/i , formatSize(layout.getScreenSize()));
	document.title = title;
}

export default {
	init() {
		if (!config.debugMode) {
			return;
		}

		screenSizeWatcher.onChange(function(){
			updateScreenSizeHint();
		});

		document.title = formatSize(layout.getScreenSize()) + ' | ' + document.title;
	}
};